// Module 5 / Slice 5 — Rota detail Positions tab.
//
// Lists rota_position rows for the current rota ordered by position_index.
// Drag-to-reorder UX is carry C-mod5-10 (Phase 4); v1 ships the read +
// data-testid surface that Playwright + Vitest hook into.

import type { components } from "../../../api/rota-config.gen";
import { useI18n } from "../../../i18n/I18nContext";

type RotaPosition = components["schemas"]["RotaPosition"];

export function PositionsTab({
  rotaId,
  positions,
}: {
  rotaId: string;
  positions: readonly RotaPosition[];
}): JSX.Element {
  const { t } = useI18n();
  if (positions.length === 0) {
    return (
      <p data-testid={`positions-tab-empty-${rotaId}`}>
        {t("rota_config.positions.empty")}
      </p>
    );
  }
  return (
    <table className="rc-table" data-testid="positions-tab-table">
      <thead>
        <tr>
          <th>{t("rota_config.positions.col.index")}</th>
          <th>{t("rota_config.positions.col.title")}</th>
          <th>{t("rota_config.positions.col.roleCode")}</th>
        </tr>
      </thead>
      <tbody>
        {positions
          .slice()
          .sort((a, b) => a.positionIndex - b.positionIndex)
          .map((p) => (
            <tr key={p.id} data-testid={`position-row-${p.id}`}>
              <td>{p.positionIndex}</td>
              <td>{p.title}</td>
              <td>{p.roleCode ?? "—"}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
